export function gizyAniamtion(anime) {

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.querySelectorAll('#idLogoBg, #idLogoWeb, #idLogo1, #idLogoPl, #idLogoKropka, #tytulStrony, #podTytul, #idTxtOferta, #idTextInfo, #idTextInfo2, .animate-item')
            .forEach((element) => {
                element.style.opacity = '1';
                element.style.transform = 'none';
            });
        return;
    }

    // sprawdzanie na jakiej stronie jesteśmy
    const pageInfo = document.getElementById('page-info');

    if (pageInfo) {
        // 2. Sprawdź atrybut danych na tym kontenerze
        const pageName = pageInfo.dataset.pageName;

        switch (pageName) {
            case 'home':
                animHome();
                break;
            case 'offer':
                animOffer();
                break;
            default:
                // Opcjonalnie: obsłuż przypadek domyślny
                console.log('Brak zdefiniowanych animacji dla tej strony.');
        }
    }

    function animHome(){


        anime.timeline({
            easing: 'easeInOutSine',
            duration: 400
        })
            .add({
                targets: '#idLogoBg',
                opacity: [0, 1]
            })
            .add({
                targets: '#idLogoWeb',
                opacity: [0, 1]
            })
            .add({
                targets: '#idLogo1',
                opacity: [0, 1]
            })
            .add({
                targets: '#idLogoPl',
                opacity: [0, 1],
                duration: 400
            })
            .add({
                targets: '#idLogoKropka',
                opacity: [0, 1],
                translateY:[-100,0],
                scale: [0, 1] ,
                duration: 600,// kropka wchodzi efektownie
            })
            .add({
                targets: '#idLogoKropka',
                keyframes: [
                    { scale: 1.5 },
                    { scale: 0.8 },
                    { scale: 1.2 },
                    { scale: 0.9 },
                    { scale: 1 }
                ],
                duration: 900,
                easing: 'easeOutSine'
            })
          .add({
            opacity: [0, 1],
            targets: '#tytulStrony',
            scale:[1.3,1],
            easing: 'easeOutSine'
        }).add({
            opacity: [0, 1],
            targets: '#podTytul',
            scale:[1.3,1],
            easing: 'easeOutSine'
        });

    }

    function animOffer(){


        const observerOptions = {
            root: null, // Viewport
            rootMargin: '0px 100px 0px 100px', // Dodajemy margines w poziomie
            threshold: 0.1 // 10% sekcji musi być widoczne
        };

        //dodać animate-item jako klasę oraz data-anim="nazwa_animacji"

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const element = entry.target;
                const animType = element.dataset.anim;

                if (entry.isIntersecting && element.dataset.animated === 'false') {
                    element.dataset.animated = 'true';

                    switch (animType) {
                        case 'programs-pc':
                            anime({
                                targets: element,
                                translateX: [-300,0],
                                opacity: [0, 1],
                                duration: 800,
                                easing: 'easeOutExpo'
                            });
                            break;

                        case 'programs-kontakt':
                            anime({
                                targets: element,
                                translateX: [1400, 0],
                                opacity: [0, 1],
                                duration: 2800,
                                easing: 'easeOutExpo',
                                rotate:[0,-6]
                            });
                            break;

                        case 'programs-wydatek':
                            anime({
                                targets: element,
                                scale: [0.1, 1.2],
                                opacity: [0, 1],
                                duration: 1800,
                                easing: 'easeOutBack',
                                rotate:[0,16]
                            });
                            break;
                        case 'www-zsr':
                            anime({
                                targets: element,
                                scale: [0.1, 1.2],
                                opacity: [0, 1],
                                duration: 1800,
                                easing: 'easeOutBack',
                                rotate:[0,16]
                            });
                            break;
                    }

                } else if (!entry.isIntersecting && element.dataset.animated === 'true') {
                    // reset
                    element.dataset.animated = 'false';
                    element.style.opacity = '0';
                    element.style.transform = '';
                }
            });
        }, observerOptions);

// Podpinasz wszystkie elementy z klasą animate-item
        document.querySelectorAll('.animate-item').forEach(el => {
            el.dataset.animated = 'false';
            observer.observe(el);
        });


        const txtOferta = document.getElementById('idTxtOferta');
        const txtInfo = document.getElementById('idTextInfo');
        const txtInfo2 = document.getElementById('idTextInfo2');

        const tl = anime.timeline({
            easing: 'easeInOutSine',
            loop: false
        });



        tl.add({
            targets: txtOferta,
            opacity: [0,1],
            translateY: [-300, 0],
            scale: [2, 1],
            duration: 700,
        });

        anime({
            targets: txtInfo,
            translateX: [300, 0],
            opacity:[0,1],
            scale: [1.5, 1],
            duration: 600,
            easing: 'easeInOutSine',
            loop: false,
        });

        anime({
            targets: txtInfo2,
            translateY: [200, 0],
            opacity:[0,1],
            scale: [1.5, 1],
            duration: 1000,
            easing: 'easeInOutSine',
            loop: false,
        });
    }

}
